$.fn.slickVimeo = function (video_ids) {
  new SlickVimeo(this, video_ids);
};

function SlickVimeo (el, video_ids) {
  var that = this,
    defaults = {
      mobile_width: 767,
      ratio: 16 / 9,
      selectors: {},
      custom_control: 0,
      player: {
        autoplay: 0,
        title: 0,
        byline: 0,
        portrait: 0,
        badge: 0,
        loop: 0,
        transparent: 0,
        background: 0,
        api: 1,
        width: 640,
        height: 360,
        controls: 1,
      }
    };
  that.options = $.extend({}, defaults);
  that.el = $(el);
  that.players = [];
  that.iframes = [];
  that.video_ids = video_ids;
  that.initialize();
}

SlickVimeo.prototype = {

  initialize: function () {
    var that = this;
    that.initPlayers(0);
  },

  initSlider: function () {
    var that = this;
    that.el.on('init', function () {
      that.play(0);
    });
    that.el.on('beforeChange', function (event, slick, currentSlide, nextSlide) {

      currentPlayer = that.getPlayer(currentSlide);
      nextPlayer = that.getPlayer(nextSlide);

      if (currentPlayer !== null) {
        if (currentSlide === nextSlide) {
          if (!currentPlayer.disableAutoplay) {
            currentPlayer.play();
          }
        } else {
          currentPlayer.pause();
        }
      }

      if (nextPlayer !== null) {
        if (currentSlide !== nextSlide) {
          if (!nextPlayer.disableAutoplay) {
            nextPlayer.play();
          }
        }
      }
    });
  },

  initPlayers: function (index) {
    var that = this,
      video_id = that.video_ids[index];
    if (typeof video_id !== 'undefined') {
      var player_container = that.el.find('#' + video_id),
        width = that.options.player.width,
        height = that.options.player.height,
        width_slider = that.el.width();
      if (that.options.mobile_width >= width && width > width_slider) {
        width = width_slider * 0.95;
        height = width / that.options.ratio;
      }
      var options = $.extend(that.options.player, {id: video_id, width: width, height: height}),
        player = new Vimeo.Player(player_container, options);
      player.disableAutoplay = false;
      player.ready().then(function () {
        that.players[video_id] = player;
        that.iframes.push(player_container);
        if(that.options.custom_control) {
          that.initButton(video_id);
        }
        that.initPlayers(index + 1);
      });
    } else {
      that.initSlider();
    }
  },

  play: function (index) {
    var that = this,
      player = that.getPlayer(index);
    if (player !== null) {
      player.play();
    }
  },

  pause: function (index) {
    var that = this,
      player = that.getPlayer(index);
    if (player !== null) {
      player.pause();
    }
  },

  getPlayer: function (slideNumber) {
    var that = this,
      playerId = that.el.find('[data-slick-index="' + slideNumber + '"]').find('[data-vimeo-initialized]').attr('id');
    return (playerId !== undefined) ? that.players[playerId] : null;
  },

  initButton: function (video_id){
    var that = this,
      player = that.players[video_id],
      player_container = that.el.find('#' + video_id),
      sliderWidth = that.el.width(),
      videoWidth = that.el.find('#' + video_id + ' iframe').width(),
      marginLeft = (sliderWidth - videoWidth)/2 + 5;

    player_container.after('<div id="video-btn-' + video_id + '" class="video-btn video-btn-pause" style="margin-left:' + marginLeft + 'px;"></div>');

    $('#video-btn-' + video_id).on('click', function (e) {
      var btn = e.currentTarget;
      e.stopPropagation();
      if (btn.className.indexOf('video-btn-pause') >= 0) {
        player.pause();
        player.disableAutoplay = true;
        btn.className ='video-btn video-btn-play';
      } else {
        player.play();
        player.disableAutoplay = false;
        btn.className = 'video-btn video-btn-pause';
      }
    });
  }
};
